module.exports = __webpack_public_path__ + "static/media/bg-brand-2.f3135f7d.jpg";